/**
 * P0-DISCOVERY-04 — compact streak indicator surfaced in the header.
 * Reads from the existing localStorage streak (loadStreak) — no new
 * queries. Click opens the existing rewards center.
 */
import { useEffect, useState } from "react";
import { Flame } from "lucide-react";
import { loadStreak } from "@/lib/retention/streaks";
import { trackEvent } from "@/lib/audit";

export function StreakBadge({ onClick }: { onClick?: () => void }) {
  const [days, setDays] = useState<number>(() => {
    try {
      return loadStreak().consecutive_days_active;
    } catch {
      return 0;
    }
  });

  useEffect(() => {
    const refresh = () => {
      try {
        setDays(loadStreak().consecutive_days_active);
      } catch {
        /* noop */
      }
    };
    refresh();
    const id = window.setInterval(refresh, 60_000);
    window.addEventListener("focus", refresh);
    return () => {
      window.clearInterval(id);
      window.removeEventListener("focus", refresh);
    };
  }, []);

  useEffect(() => {
    if (days > 0) void trackEvent("streak_badge_shown", { days });
  }, [days]);

  if (days <= 0) return null;

  return (
    <button
      type="button"
      onClick={() => {
        void trackEvent("streak_badge_clicked", { days });
        onClick?.();
      }}
      aria-label={`Racha de ${days} días`}
      title={`Racha · ${days} días`}
      className="flex h-9 items-center gap-1 rounded-full border border-[oklch(0.78_0.2_50)]/60 bg-[oklch(0.78_0.2_50)]/15 px-2.5 text-[11px] font-black text-[oklch(0.78_0.2_50)] transition hover:bg-[oklch(0.78_0.2_50)]/25"
    >
      <Flame className="h-3.5 w-3.5" />
      <span className="tabular-nums">{days}</span>
      <span className="hidden sm:inline">días</span>
    </button>
  );
}
